import { useState, useEffect, useContext } from "react";
import dashboardServices from "../services/hoa-dashboard-api-service";
import datastore from "../store/hoa-datastore";
import { GlobalContext } from '../context/hoa-global-context';

export default function useHoaViewController(selectedValues:any) {
    const [isLogLoading, updateLogLoading] = useState(false);
	const [hoaProperties,setHoaProperties] = useState({
        data:[],
        pageNumber:1,
        isLastPage:false,
    });
	const [appLogs,setAppLogs] = useState({
        data:[],
        count: null,
        pageNumber:1,
        isLastPage:false,
    });
	const numberOfProjects = Math.ceil((window.innerHeight - datastore.responsiveHeight) / 60);


	const { setViewMoreDetails, changeActiveMenu, updateSelectedValues, viewMoreDetails } = useContext<any>(GlobalContext)
    
	const getCreatedLogs = async (page: number, options?: any) => {
		updateLogLoading(true);
		const {status, data} = await dashboardServices.getCreatedLogs(selectedValues.objectId, numberOfProjects, page, options);
		if(status == 200) {
			const { createdlogs, totalCount } = data;
			let isLastPage = [...appLogs.data, ...createdlogs].length >= totalCount
			datastore.createdLogs[selectedValues.objectId] = createdlogs;
			if(Object.values(options).length){
				let tempLogs = {...appLogs};
				tempLogs.data = createdlogs;
				tempLogs.pageNumber = 1;
				tempLogs.isLastPage = isLastPage;
				tempLogs.count = totalCount;
	
				datastore.createdLogs[selectedValues.objectId] = tempLogs;
				setAppLogs(tempLogs);
			}else{
				const mergedLogs = [...appLogs.data, ...createdlogs];
				const uniqueLogs = mergedLogs.filter(
					(log, index, self) =>
					  index === self.findIndex((t) => t.objectId === log.objectId)
				  );
				let tempLogs = {...appLogs};
				tempLogs.data = uniqueLogs;
				tempLogs.pageNumber = appLogs.pageNumber+1;
				tempLogs.isLastPage = isLastPage;
				tempLogs.count = totalCount;
	
				datastore.createdLogs[selectedValues.objectId] = tempLogs;
				setAppLogs(tempLogs);
			}
			updateLogLoading(false);
		}
	};

	useEffect(() => {
		if(!datastore.createdLogs[selectedValues.objectId]) {
			const options = {
				...(datastore.selectedOrganization?.id ? { 'orgId': datastore.selectedOrganization?.id } : {}),
			}
			getCreatedLogs(appLogs.pageNumber, options);
		} else {
			setAppLogs(datastore.createdLogs[selectedValues.objectId]);
		}
		return ()=>{
			setAppLogs({
				count: null,
				data: [],
				isLastPage: false,
				pageNumber: null
			})
		}
	}, [selectedValues.objectId]);

	const onViewMunicipalityDetailsClick = () => {
		if(viewMoreDetails?.prevTagType === 'Properties') return;

		changeActiveMenu('Municipalities',true)
		updateSelectedValues(selectedValues['municipality'])
		setViewMoreDetails({
			prevTagType:'HOAs',
			prevValues: selectedValues
		})
	}


    return {
        appLogs,
        isLogLoading,
        setAppLogs,
        updateLogLoading,
        getCreatedLogs, 
		hoaProperties,
		setHoaProperties,
		onViewMunicipalityDetailsClick
    }
}
